/**
 * Pipefitter UI — aligned with Project Materials / Material Traceability.
 * @see src/features/project/components/dashboard/materials/ProjectMaterials.tsx
 */

/** Chart hex values (ApexCharts / inline styles). */
export const PIPEFITTER_CHART_COLORS = {
  primary: '#e04530',
  secondaryOrange: '#ed8b00',
  secondaryGreen: '#60b885',
  secondaryRed: '#e4002b',
  gray: '#718096',
  grayDark: '#4a5568',
  border: '#e5e7eb',
  foreground: '#6b7280',
} as const;

/** Same TabsTrigger classes as Material Traceability category tabs. */
export const PIPEFITTER_TAB_TRIGGER_CLASS =
  'relative inline-flex items-center border-b-2 border-transparent -mb-[2px] px-1 pb-3 pt-2 text-[13px] font-medium text-heritage-grey hover:text-blueprint-blue data-[state=active]:border-hero-red data-[state=active]:text-blueprint-blue transition-colors duration-150';

export const PIPEFITTER_TAB_LIST_WRAPPER_CLASS =
  'sticky top-0 bg-white z-10 border-b-2 border-[#E2E5EA] flex items-end';

/** Full-screen dialog shell (matches ProjectLimitsModal). */
export const PIPEFITTER_FULLSCREEN_DIALOG_CLASS =
  '!left-0 !top-0 !h-screen !max-h-screen !w-screen !max-w-none !translate-x-0 !translate-y-0 m-0 gap-0 rounded-none border-0 bg-page-bg p-0 shadow-none [&>button]:hidden';

/** Report history detail above Reports modal. */
export const PIPEFITTER_FULLSCREEN_DIALOG_Z60 = `${PIPEFITTER_FULLSCREEN_DIALOG_CLASS} z-[60]`;

/** Generate modals opened above report history detail. */
export const PIPEFITTER_FULLSCREEN_DIALOG_Z70 = `${PIPEFITTER_FULLSCREEN_DIALOG_CLASS} z-[70]`;

export const PIPEFITTER_STACKED_DIALOG_OVERLAY_CLASS = 'z-[65]';
